import { render } from "./coursedetailed.vue?vue&type=template&id=5b3c86fd"
import script from "./coursedetailed.vue?vue&type=script&lang=js"
export * from "./coursedetailed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__